import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sidebar-header" }
const _hoisted_2 = { class: "sidebar-title" }
const _hoisted_3 = { class: "sidebar-listing" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBarListings = _resolveComponent("SideBarListings")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-pane", {'mobile-width' : _ctx.isMobile}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.SideBar.Title")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorizedListings, (emailType, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "sidebar-category"
        }, [
          _createVNode(_component_SideBarListings, {
            "email-type": idx,
            "email-category-listing": emailType,
            "active-tab": _ctx.currentSelectedTab
          }, null, 8, ["email-type", "email-category-listing", "active-tab"])
        ]))
      }), 128))
    ])
  ], 2))
}